import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { COPY } from "../content/copy";
import { Monogram } from "./Monogram";
import ThemeToggle from "./ThemeToggle";
import { scrollToId } from "../lib/scroll";
import { track } from "../lib/track";

export default function Header() {
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(null);
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const reduced = pathname === "/analisi";
    const [pastIntro, setPastIntro] = useState(false);
    const [atForm, setAtForm] = useState(false);
    useEffect(() => {
        const on = () => {
            setPastIntro(window.scrollY > window.innerHeight * (document.body.classList.contains("pin-mode") ? 3.6 : 1.2));
            const headerHeight = document.querySelector(".site-header")?.getBoundingClientRect().height || 0;
            setAtForm(Array.from(document.querySelectorAll(".lead-form")).some((form) => {
                const box = form.getBoundingClientRect();
                return box.top < window.innerHeight - 16 && box.bottom > headerHeight;
            }));
        };
        window.addEventListener("scroll", on, { passive: true });
        window.addEventListener("resize", on);
        on();
        return () => {
            window.removeEventListener("scroll", on);
            window.removeEventListener("resize", on);
        };
    }, [pathname]);

    useEffect(() => {
        const ids = COPY.nav.filter((n) => !n.to).map((n) => n.id);
        const onScroll = () => {
            let cur = null;
            for (const id of ids) {
                const el = document.getElementById(id);
                if (
                    el &&
                    el.getBoundingClientRect().top < window.innerHeight * 0.4
                )
                    cur = id;
            }
            setActive(cur);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        if (open && window.__lenis) window.__lenis.stop();
        if (!open && window.__lenis) window.__lenis.start();
        document.body.classList.toggle("menu-open", open);
    }, [open]);

    const go = (id, to) => {
        setOpen(false);
        if (to) {
            navigate(to);
            return;
        }
        if (pathname !== "/") {
            navigate(`/#${id}`);
            return;
        }
        setTimeout(() => scrollToId(id), open ? 60 : 0);
    };

    return (
        <>
            <header className="site-header" data-testid="site-header">
                <a
                    className="header-logo"
                    href="/"
                    data-testid="header-logo"
                    onClick={(e) => {
                        e.preventDefault();
                        setOpen(false);
                        if (pathname !== "/") {
                            navigate("/");
                            return;
                        }
                        if (window.__lenis)
                            window.__lenis.scrollTo(0, { duration: 1.4 });
                        else window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                >
                    <Monogram className="header-tri" />
                    <span className="header-name">
                        <span className="header-name-serif">APF</span>
                        <span className="header-name-sans">Partners</span>
                    </span>
                </a>
                <div className="header-right">
                    {!reduced && <nav className="header-nav" aria-label="Principale">
                        {COPY.nav.map((n) => (
                            <a
                                key={n.id}
                                href={n.to || `#${n.id}`}
                                className={`tlink header-link ${
                                    active === n.id || (n.to && pathname.startsWith(n.to)) ? "active" : ""
                                }`}
                                data-testid={`header-link-${n.id}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    go(n.id, n.to);
                                }}
                            >
                                {n.label}
                            </a>
                        ))}
                    </nav>}
                    <ThemeToggle />
                    {!reduced && (
                        <button
                            className="btn btn-solid header-cta"
                            data-testid="header-cta"
                            onClick={() => {
                                track("header_cta_click");
                                go("cominciare");
                            }}
                        >
                            {COPY.cta}
                        </button>
                    )}
                    {!reduced && <button
                        className="menu-btn"
                        data-testid="menu-button"
                        onClick={() => setOpen(true)}
                    >
                        Menu
                    </button>}
                </div>
            </header>

            {pathname === "/" && (
                <div className={`mobile-bar ${pastIntro && !atForm ? "show" : ""}`} data-testid="mobile-cta-bar" inert={!pastIntro || atForm || open}>
                    <button
                        className="btn btn-solid"
                        data-testid="mobile-cta"
                        onClick={() => {
                            track("header_cta_click", { position: "mobile-bar" });
                            go("cominciare");
                        }}
                    >
                        {COPY.cta}
                    </button>
                </div>
            )}
            <div
                className={`menu-overlay ${open ? "open" : ""}`}
                data-testid="menu-overlay"
                aria-hidden={!open}
            >
                <button
                    className="menu-close"
                    data-testid="menu-close"
                    onClick={() => setOpen(false)}
                >
                    Chiudi
                </button>
                {COPY.nav.map((n) => (
                    <a
                        key={n.id}
                        href={n.to || `#${n.id}`}
                        className="menu-link"
                        data-testid={`menu-link-${n.id}`}
                        onClick={(e) => {
                            e.preventDefault();
                            go(n.id, n.to);
                        }}
                    >
                        {n.label}
                    </a>
                ))}
            </div>
        </>
    );
}
